import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ActionService } from 'src/app/core/services/action.service';
import { ErrorsEnum, ErrorService } from 'src/app/core/services/error.service';
import { SnackBarService } from 'src/app/core/services/snack-bar.service';
import { toExcelFormat } from 'src/app/helpers/format-position';
import { ConfirmModalComponent } from 'src/app/modals/confirm-modal/confirm-modal.component';
import { PigeonholePositionInfo } from 'src/models/Pigeonhole';
import { TaskRequestSidenavService } from 'src/app/core/services/task-request-sidenav.service';

@Component({
  selector: 'app-position-info-card',
  templateUrl: './position-info-card.component.html',
  styleUrls: ['./position-info-card.component.scss']
})
export class PositionInfoCardComponent implements OnInit {

  @Input() position: PigeonholePositionInfo & { coords: string };
  notificationData: { type: string; title: string; message: string; };
  @ViewChild('notification', { static: true }) notificationTmpl;

  constructor(
    private dialog: MatDialog,
    private actionService: ActionService,
    private snackBarService: SnackBarService,
    private errorService: ErrorService,
    private router: Router,
    private sidenavService: TaskRequestSidenavService,
  ) { }

  ngOnInit(): void {
  }

  formatCoords(): string {
    if (!this.position) return '---';
    this.position.coords = `${toExcelFormat(this.position.x, this.position.y)} (x:${this.position.x} y:${this.position.y})`;
    return this.position.coords;
  }

  onRemovePosition() {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      panelClass: 'confirm-modal',
      autoFocus: false,
      data: {
        label: `Você tem certeza que deseja excluir a posição ${this.position.coords}?\nEsta ação não pode ser desfeita.`,
        confirmBtnClass: 'alert'
      }
    });
    dialogRef.afterClosed().subscribe(async (res) => {
      if (res) {
        try {
          await this.actionService.deletePosition({ rfid: this.position.rfid });
          this.notificationData = {
            type: 'success',
            title: 'Posição excluída com sucesso!',
            message: `A posição ${this.position.coords} foi excluída com sucesso.`
          };
          //TODO: refatorar esse sistema de notificação
          const notificationId = '123';
          this.snackBarService.showFeedback(this.notificationTmpl, this.notificationData, notificationId);
          setTimeout(() => {
            this.snackBarService.hideNotification(notificationId);
            this.router.navigate(['/map']);
          }, 5000);
        } catch (err) {
          const error = err?.error?.body;
          if (!error || !error.type) return;

          switch (error.type) {
            case ErrorsEnum.FORBIDDEN_ACTION_FOR_USER_TYPE:
              this.errorService.openErrorSnackBarWithCustomMessage(`Funcionalidade permitida apenas para usuários Master.`);
              break;
            case ErrorsEnum.GROUND_POSITION_WITH_TASK:
              this.errorService.openErrorSnackBarWithCustomMessage(`Não é permitido excluir posições que tenham tarefas relacionadas. Complete ou remova as tarefas e tente novamente.`);
              break;
            case ErrorsEnum.GROUND_POSITION_WITH_PALLET:
              this.errorService.openErrorSnackBarWithCustomMessage(`Não é permitido excluir posições ocupadas por paletes. Esvazie a posição e tente novamente.`);
              break;
          }
        }
      }
    });
  }

  openInventorySidenav() {
    this.sidenavService.toggle({
      type: 'PIGEONHOLE_INVENTORY',
      data: this.position,
    });
  }

}
